<script>
import moment from "moment";

import Portal from "../../layouts/portal";
import Membresia from "@/components/portal-membresia";
import { clienteComputed } from "@/state/helpers";
import { cargarSesion } from "@/services/portal";
import { urlIncrustadaVimeo } from "@/services/vimeo";

export default {
  page: { title: "Sesión" },
  components: { Portal, Membresia },
  data() {
    return {
      sesion: null,
      cargando: true,
      error: null,
    };
  },
  computed: {
    ...clienteComputed,
    urlVideo() {
      return this.sesion ? urlIncrustadaVimeo(this.sesion.video) : null;
    },
    fecha() {
      if (!this.sesion) return "";
      if (this.sesion.fecha) return this.sesion.fecha;
      if (this.sesion.timestamp && this.sesion.timestamp.toDate) {
        return moment(this.sesion.timestamp.toDate()).format("DD [de] MMMM [de] YYYY");
      }
      return "";
    },
    redes() {
      if (!this.sesion) return [];
      return [
        { url: this.sesion.spotify, icono: "mdi mdi-spotify", texto: "Spotify" },
        { url: this.sesion.instagram, icono: "mdi mdi-instagram", texto: "Instagram" },
        { url: this.sesion.facebook, icono: "mdi mdi-facebook", texto: "Facebook" },
      ].filter((r) => r.url);
    },
  },
  methods: {
    async cargar() {
      this.cargando = true;
      try {
        this.sesion = await cargarSesion(this.$route.params.id);
        if (!this.sesion) this.error = "Esta sesión ya no está disponible.";
      } catch (err) {
        console.error("[portal] error al cargar la sesión:", err);
        this.error = "No pudimos cargar la sesión. Inténtalo de nuevo en un momento.";
      } finally {
        this.cargando = false;
      }
    },
  },
  mounted() {
    if (this.tieneMembresia) this.cargar();
    else this.cargando = false;
  },
  watch: {
    tieneMembresia(nuevo) {
      if (nuevo && !this.sesion) this.cargar();
    },
  },
};
</script>

<template>
  <Portal>
    <router-link :to="{ name: 'portal-sesiones' }" class="text-muted d-inline-block mb-3">
      <i class="mdi mdi-arrow-left"></i> Volver a sesiones
    </router-link>

    <Membresia v-if="!tieneMembresia && !cargandoCliente" seccion="Esta sesión" />

    <template v-else>
      <p v-if="cargando" class="text-muted">Cargando…</p>
      <b-alert :show="!!error" variant="warning">{{ error }}</b-alert>

      <div v-if="sesion" class="sesion-detalle">
        <div v-if="urlVideo" class="sesion-video">
          <iframe :src="urlVideo" frameborder="0" allow="autoplay; fullscreen; picture-in-picture"
            allowfullscreen :title="sesion.titulo"></iframe>
        </div>
        <b-alert v-else show variant="secondary">
          Esta sesión todavía no tiene video publicado.
        </b-alert>

        <div class="sesion-info">
          <h1 class="h3 mb-1">{{ sesion.titulo }}</h1>
          <p class="text-muted mb-3">
            <span v-if="sesion.autor">{{ sesion.autor }}</span>
            <span v-if="sesion.ciudad"> · {{ sesion.ciudad }}</span>
            <span v-if="fecha"> · {{ fecha }}</span>
          </p>

          <p v-if="sesion.descripcion" class="sesion-descripcion">{{ sesion.descripcion }}</p>

          <div v-if="redes.length" class="mt-4">
            <a v-for="r in redes" :key="r.texto" :href="r.url" target="_blank" rel="noopener noreferrer"
              class="btn btn-outline-primary btn-sm mr-2">
              <i :class="r.icono"></i> {{ r.texto }}
            </a>
          </div>
        </div>
      </div>
    </template>
  </Portal>
</template>

<style scoped>
.sesion-detalle {
  background: #fff;
  border: 1px solid #e9ecef;
  border-radius: 12px;
  overflow: hidden;
}

.sesion-video {
  position: relative;
  aspect-ratio: 16 / 9;
  background: #000;
}

.sesion-video iframe {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
}

.sesion-info {
  padding: 24px;
}

.sesion-descripcion {
  white-space: pre-wrap;
  line-height: 1.6;
}
</style>
